(function () {
  var DEBUG = true;

  function log() {
    if (DEBUG) console.log.apply(console, ['[metal-purity]'].concat(Array.prototype.slice.call(arguments)));
  }

  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function isMaterialOption(name) {
    var n = normalize(name);
    return n.includes('material') || n === 'metal';
  }

  function isPurityOption(name) {
    var n = normalize(name);
    return n.includes('purity') || n.includes('karat') || n.includes('carat');
  }

  function isSilverValue(text) {
    return normalize(text).includes('silver');
  }

  function isPlaceholderValue(text) {
    var n = normalize(text);
    if (n === '' || n === 'n/a' || n === 'na') return true;
    return /^[-\u2010-\u2015\u2212]+$/.test(n);
  }

  function isNineK(text) {
    return normalize(text).replace(/\s+/g, '') === '9k';
  }

  function syncVariantSelects(root) {
    var fieldsets = root.querySelectorAll('fieldset[data-option-name]');
    var materialFieldset = null;
    var purityFieldset = null;

    fieldsets.forEach(function (fs) {
      var name = fs.getAttribute('data-option-name');
      if (isMaterialOption(name)) materialFieldset = fs;
      if (isPurityOption(name)) purityFieldset = fs;
    });

    if (!materialFieldset || !purityFieldset) return;

    var checkedMaterialInput = materialFieldset.querySelector('input:checked');
    if (!checkedMaterialInput) return;

    var materialIsSilver = isSilverValue(checkedMaterialInput.value);
    log('checked material value:', checkedMaterialInput.value, '| isSilver:', materialIsSilver);

    var purityInputs = Array.from(purityFieldset.querySelectorAll('input[type="radio"]'));
    var checkedPurityInput = purityFieldset.querySelector('input:checked');

    if (materialIsSilver) {
      if (!purityFieldset.hidden) {
        purityFieldset.hidden = true;
        log('hid purity fieldset');
      }

      // Silver only ever pairs with the placeholder value. If a real karat
      // (e.g. 9K, forced earlier while Gold was selected) is still checked
      // underneath, that combination doesn't exist as a variant and the
      // price disappears -- so force the placeholder back on for Silver.
      var needsPlaceholder = !checkedPurityInput || !isPlaceholderValue(checkedPurityInput.value);

      if (needsPlaceholder) {
        var placeholderInput = purityInputs.find(function (input) { return isPlaceholderValue(input.value); });
        log('resolved placeholder purity input:', placeholderInput ? placeholderInput.value : '(none found)');

        if (placeholderInput && !placeholderInput.checked) {
          placeholderInput.checked = true;
          log('forcing checked + dispatching change on placeholder:', placeholderInput.value);
          placeholderInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else {
      if (purityFieldset.hidden) {
        purityFieldset.hidden = false;
        log('unhid purity fieldset');
      }

      var userHasRealPuritySelected = checkedPurityInput && !isPlaceholderValue(checkedPurityInput.value);

      if (!userHasRealPuritySelected) {
        var nineKInput = purityInputs.find(function (input) { return isNineK(input.value); });
        var defaultInput = nineKInput || purityInputs.find(function (input) { return !isPlaceholderValue(input.value); });

        log('resolved default purity input:', defaultInput ? defaultInput.value : '(none found)', '| already checked:', defaultInput && defaultInput.checked);

        if (defaultInput && !defaultInput.checked) {
          defaultInput.checked = true;
          log('forcing checked + dispatching change on:', defaultInput.value);
          defaultInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        log('leaving as-is, user already picked:', checkedPurityInput.value);
      }
    }
  }

  function syncAll() {
    var allSelects = document.querySelectorAll('variant-selects');
    allSelects.forEach(function (root) {
      if (root.style.display === 'none') return;
      syncVariantSelects(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    log('DOMContentLoaded fired');
    syncAll();

    var container = document.querySelector('product-info') || document.body;
    var pending = null;

    var observer = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        log('DOM change detected, re-syncing');
        syncAll();
      }, 50);
    });

    observer.observe(container, { childList: true, subtree: true });
    log('MutationObserver attached to', container.tagName);
  });
})();